import {
  css
} from 'lit';

export const AskLillyLogoStyle = css`
.lds-logo-ask-lilly {
  height: 2.5rem;
}
.lds-logo-ask-lilly-ask {
  fill: #6d625d;
}
.lds-logo-ask-lilly-lilly {
  fill: #d52b1e;
}
`;

export default AskLillyLogoStyle;
